import { getStudentView } from "./studentView";

const ADMIN_IDS = new Set(["SMADMIN"]);

export function resolveUserRole(studentId, storedRole) {
  if (getStudentView()) return "student";
  const sid = String(studentId || "").trim().toUpperCase();
  if (ADMIN_IDS.has(sid)) return "admin";
  const role = String(storedRole || "").trim().toLowerCase();
  return role || "student";
}

export function getUserRole(user, storedRole) {
  if (user && typeof user === "object") {
    return resolveUserRole(user.student_id || user.username || user.id, user.role ?? storedRole);
  }
  return resolveUserRole(user, storedRole);
}

export function isAdminUser(user, storedRole) {
  if (getStudentView()) return false;
  if (user && typeof user === "object") {
    if (user.is_admin === true) return true;
    return getUserRole(user, storedRole) === "admin";
  }
  return resolveUserRole(user, storedRole) === "admin";
}

export function isTutorUser(user, storedRole) {
  if (getStudentView()) return false;
  if (user && typeof user === "object") {
    if (user.is_tutor === true) return true;
    return getUserRole(user, storedRole) === "tutor";
  }
  return resolveUserRole(user, storedRole) === "tutor";
}

export function canAccessTutorTools(user, storedRole) {
  const role = getUserRole(user, storedRole);
  return role === "tutor" || role === "admin";
}

export function getAuthUserHeader() {
  return localStorage.getItem("student_id") || localStorage.getItem("role") || "";
}

export function isEmailIdentity(value) {
  return String(value || "").trim().includes("@");
}

export function readStoredAuthUser() {
  const view = getStudentView();
  if (view) return { student_id: view.student_id, username: view.student_id, name: view.name, role: "student", is_admin: false, read_only: true };
  try {
    const raw = localStorage.getItem("auth_user") || sessionStorage.getItem("auth_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasStaleEmailAuthState() {
  const stored = readStoredAuthUser();
  return [
    localStorage.getItem("student_id") || sessionStorage.getItem("student_id"),
    stored?.id,
    stored?.user_id,
    stored?.student_id,
    stored?.username,
    stored?.name,
  ].some(isEmailIdentity);
}

export function persistCanonicalAuthUser(user) {
  const studentId = String(user?.student_id || user?.username || "").trim().toUpperCase();
  if (!studentId || isEmailIdentity(studentId)) return false;
  const canonical = { ...user, student_id: studentId, username: studentId };
  const values = {
    student_id: studentId,
    student_name: String(user?.name || studentId),
    role: String(user?.role || "student").toLowerCase(),
    is_admin: user?.is_admin ? "1" : "0",
    payment_made: user?.payment_made ? "1" : "0",
    auth_user: JSON.stringify(canonical),
  };
  Object.entries(values).forEach(([key, value]) => {
    localStorage.setItem(key, value);
    sessionStorage.setItem(key, value);
  });
  return true;
}
